(function () {
  const ADULT_SUFFIX_REGEX = /\s*-tag:\+18/g;
  const SEARCH_PATH_FRAGMENT = '/search';

  function isAdultSearchEnabled() {
    try {
      return sessionStorage.getItem('eupoupo_age_verified') === 'true'
        && sessionStorage.getItem('eupoupo_adult_search') === 'true';
    } catch (e) {
      return false;
    }
  }

  // Shopify's default search is fuzzy: every query (even "xyzabc") fills up to ~1000
  // loosely related results, so facets list every brand. Quoting each word makes the
  // match exact. When the exact search finds nothing, main-search.liquid redirects to
  // the loose query and remembers it here so we don't quote it again (no redirect loop).
  const LOOSE_FLAG_KEY = 'eupoupo_search_loose';
  const STRICT_TOKEN_REGEX = /^[\p{L}\p{N}][\p{L}\p{N}-]*$/u;
  const STRICT_MAX_TOKENS = 8;
  // A full UPC / EAN-13 / GTIN-14. Shorter digit strings are left alone: many SKUs are
  // 8-11 digits and Shopify matches those on its own, while a barcode field search does not.
  const BARCODE_DIGITS_REGEX = /^\d{12,14}$/;
  const BARCODE_QUERY_REGEX = /^\(variants\.barcode:(\d{12,14}) OR variants\.sku:\1\)$/;

  function barcodeQuery(code) {
    return `(variants.barcode:${code} OR variants.sku:${code})`;
  }

  function getLooseFlag() {
    try {
      return sessionStorage.getItem(LOOSE_FLAG_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function clearLooseFlag() {
    try {
      sessionStorage.removeItem(LOOSE_FLAG_KEY);
    } catch (e) {
      /* sessionStorage unavailable */
    }
  }

  function strictifyQuery(plainQuery) {
    const tokens = plainQuery.split(/\s+/).filter(Boolean);
    if (!tokens.length || tokens.length > STRICT_MAX_TOKENS) return plainQuery;
    // Anything with quotes, operators, wildcards or apostrophes is left untouched.
    if (!tokens.every((token) => STRICT_TOKEN_REGEX.test(token))) return plainQuery;
    return tokens.map((token) => `"${token}"`).join(' ');
  }

  function normalizeQuery(value, adultEnabled, strict) {
    const rawValue = (value || '').trim();
    if (!rawValue) return rawValue;
    const withoutAdultTag = rawValue.replace(ADULT_SUFFIX_REGEX, '').trim();
    // Shopify only treats a bare number as a barcode when it is the whole query. The adult
    // exclusion (-tag:+18) and quoting both disable that, so a full code is rewritten to an
    // explicit barcode/SKU field search. Runs for the search page and the predictive dropdown.
    const rewritten = withoutAdultTag.match(BARCODE_QUERY_REGEX);
    const barcode = rewritten
      ? rewritten[1]
      : (BARCODE_DIGITS_REGEX.test(withoutAdultTag) ? withoutAdultTag : '');
    const base = barcode
      ? barcodeQuery(barcode)
      : (strict && withoutAdultTag !== getLooseFlag()
        ? strictifyQuery(withoutAdultTag)
        : withoutAdultTag);
    return adultEnabled ? base : `${base} -tag:+18`.trim();
  }

  function replaceLocationSearch(params) {
    const nextQuery = params.toString();
    const nextUrl = nextQuery ? `${window.location.pathname}?${nextQuery}` : window.location.pathname;
    window.location.replace(nextUrl);
  }

  function normalizeSearchPageUrl() {
    if (window.location.pathname.indexOf(SEARCH_PATH_FRAGMENT) === -1) return;

    const params = new URLSearchParams(window.location.search);
    const adultParam = params.get('adult');
    if (adultParam !== null) {
      params.delete('adult');
      replaceLocationSearch(params);
      return;
    }

    const currentQuery = params.get('q');
    if (!currentQuery) return;

    const nextQuery = normalizeQuery(currentQuery, isAdultSearchEnabled(), true);
    if (nextQuery !== currentQuery.trim()) {
      params.set('q', nextQuery);
      replaceLocationSearch(params);
    }
  }

  function isThemeSearchForm(form) {
    if (!form || !form.tagName || form.tagName !== 'FORM') return false;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf(SEARCH_PATH_FRAGMENT) === -1) return false;
    if (!form.querySelector('input[name="q"]')) return false;
    return form.classList.contains('search')
      || Boolean(form.closest('search'))
      || Boolean(form.closest('predictive-search'))
      || Boolean(form.closest('.template-search'))
      || Boolean(form.closest('.template-404'));
  }

  function bindSearchSubmitNormalization() {
    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!isThemeSearchForm(form)) return;

      const queryInput = form.querySelector('input[name="q"]');
      if (!queryInput || !queryInput.value) return;

      // A new submit is a new search: forget the "exact search found nothing" fallback.
      clearLooseFlag();
      const nextQuery = normalizeQuery(queryInput.value, isAdultSearchEnabled(), true);
      if (nextQuery === queryInput.value.trim()) return;

      event.preventDefault();
      const params = new URLSearchParams(new FormData(form));
      params.set('q', nextQuery);
      window.location.href = `${form.getAttribute('action') || '/search'}?${params.toString()}`;
    }, true);
  }

  function initAdultSearchToggle() {
    const wrap = document.getElementById('adult-search-toggle');
    const checkbox = document.getElementById('adult-search-checkbox');
    if (!wrap || !checkbox) return;

    try {
      if (sessionStorage.getItem('eupoupo_age_verified') !== 'true') {
        wrap.hidden = true;
        return;
      }

      wrap.hidden = false;
      checkbox.checked = sessionStorage.getItem('eupoupo_adult_search') === 'true';
      if (checkbox.dataset.adultToggleBound === 'true') return;
      checkbox.dataset.adultToggleBound = 'true';
      checkbox.addEventListener('change', function () {
        sessionStorage.setItem('eupoupo_adult_search', checkbox.checked ? 'true' : 'false');
        const params = new URLSearchParams(window.location.search);
        const headerInput = document.querySelector('#Search-In-Modal-1');
        const currentQuery = params.get('q') || (headerInput ? headerInput.value : '') || '';
        params.set('q', normalizeQuery(currentQuery, checkbox.checked, true));
        if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');
        window.location.href = '/search?' + params.toString();
      });
    } catch (e) {
      wrap.hidden = true;
    }
  }

  function cleanVisibleAdultTerms(root) {
    root.querySelectorAll('input[name="q"]').forEach(function (input) {
      if (input.type === 'hidden') return;
      if (input.value.indexOf('-tag:') !== -1) {
        input.value = input.value.replace(ADULT_SUFFIX_REGEX, '').trim();
      }
    });

    root.querySelectorAll('.page-title, .template-search__header h1, [class*="breadcrumb"], .search__form-text').forEach(function (el) {
      if (el.textContent.indexOf('-tag:') !== -1) {
        el.textContent = el.textContent.replace(ADULT_SUFFIX_REGEX, '').trim();
      }
    });
  }

  function onDomReady() {
    initAdultSearchToggle();
    cleanVisibleAdultTerms(document);
  }

  normalizeSearchPageUrl();
  bindSearchSubmitNormalization();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
  } else {
    onDomReady();
  }

  window.eupoupoNormalizeSearchQuery = normalizeQuery;
  window.eupoupoIsAdultSearchEnabled = isAdultSearchEnabled;
})();
